import { Box, Button, IconButton, InputAdornment, Stack, TextField } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { ReactNode } from "react";
import Iconify from "../../minimals/components/iconify";

type ReviewFieldHoverProps = { onMouseEnter: () => void; onMouseLeave: () => void };

interface PropertyParcelsProps {
  parcelIds: string[];
  parcelError?: boolean;
  setParcelIds: (parcelIds: string[]) => void;
  lockedParcelIds?: string[];
  isEditMode?: boolean;
  disabled?: boolean;
  renderReviewActions?: (fieldId: string, displayedValue: unknown) => ReactNode;
  getReviewFieldHoverProps?: (fieldId: string) => ReviewFieldHoverProps;
  getReviewFieldHighlightSx?: (fieldId: string) => SxProps<Theme>;
}

const PropertyParcels = ({ parcelIds, parcelError, setParcelIds, lockedParcelIds, isEditMode, disabled, renderReviewActions, getReviewFieldHoverProps, getReviewFieldHighlightSx }: PropertyParcelsProps) => {
  const isDisabled = Boolean(disabled);

  const handleParcelChange = (value: string, index: number): void => {
    const newParcelIds = [...parcelIds];
    newParcelIds[index] = value;
    setParcelIds(newParcelIds);
  };

  const addParcel = (): void => {
    setParcelIds([...parcelIds, ""]);
  };

  const removeParcel = (index: number): void => {
    const newParcelIds = [...parcelIds];
    newParcelIds.splice(index, 1);
    setParcelIds(newParcelIds);
  };

  return (
    <Stack direction="column" spacing={2}>
      {parcelIds.map((parcelId, index) => (
        <Stack key={index} direction="row" alignItems="center" spacing={2}>
          <Box width="70%">
            <TextField
              label={`Parcel ${parcelIds.length > 1 ? index + 1 : ""}`}
              value={parcelId}
              {...getReviewFieldHoverProps?.(`propertyParcelId:${index}`)}
              sx={getReviewFieldHighlightSx?.(`propertyParcelId:${index}`)}
              onChange={(e) => handleParcelChange(e.target.value, index)}
              error={index === 0 && parcelError}
              fullWidth
              disabled={isDisabled || (isEditMode && Boolean(lockedParcelIds?.[index]))}
              InputProps={{
                endAdornment: (
                  <>
                    {renderReviewActions && (
                      <InputAdornment position="end">{renderReviewActions(`propertyParcelId:${index}`, parcelId)}</InputAdornment>
                    )}
                    <IconButton
                      onClick={() => removeParcel(index)}
                      aria-label="delete parcel"
                      size="small"
                      disabled={isDisabled}
                      sx={{ visibility: parcelIds.length > 1 && !isDisabled && !(isEditMode && Boolean(lockedParcelIds?.[index])) ? "visible" : "hidden" }}
                    >
                      <Iconify icon={"eva:trash-2-outline"} />
                    </IconButton>
                  </>
                )
              }}
            />
          </Box>
          {parcelIds.length - 1 === index && (
            <Button size="small" startIcon={<Iconify icon={"eva:plus-fill"} />} onClick={addParcel} disabled={isDisabled}>
              Parcel
            </Button>
          )}
        </Stack>
      ))}
    </Stack>
  );
};

export default PropertyParcels;
